import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "./SessionContext";

// Wraps every authenticated route (see App.tsx). No session -> straight to
// /auth, remembering the originally requested location in router state so
// AuthPage can send the user back there after a successful login instead of
// always landing on /dashboard. Also reacts live to session state changing
// underneath an already-mounted route (e.g. a 401 mid-session dispatches
// "lendcord:session-expired" — see apiClient.ts / SessionContext.tsx) by
// redirecting immediately rather than waiting for the next navigation.
export function RequireAuth() {
  const { isAuthenticated } = useSession();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
